import { analytics, logEvent } from '../lib/firebase';
import { getTF } from '../lib/config';
import log from '../utils/logger';

interface GameLaunchParameters {
    source: string;
    launchCode: string;
    provider: string;
    name: string;
    mode: 'real' | 'demo';
    platformID?: number;
    partnerID?: string;
}

/**
 * Track game launch event in Google Analytics
 */
export const trackGameLaunch = (parameters: GameLaunchParameters) => {
    // Log to console in development
    if (import.meta.env.DEV) {
        log.debug('📊 Analytics - Game Launch:', parameters);
    }
    
    // Send to Google Analytics only in production
    if (analytics) {
        logEvent(analytics, 'wb_game_launch', {
            source: parameters.source,
            launchCode: parameters.launchCode,
            provider: parameters.provider,
            name: parameters.name,
            mode: parameters.mode,
            platformID: parameters.platformID,
            partnerID: parameters.partnerID,
            tf: getTF(),
            timestamp: new Date().toISOString()
        });
    }
};